import styled, { css } from 'react-emotion';
import React from 'react';
import { 
  space,
  width,
  fontSize,
  color,
  textAlign,
  justifyContent,
  responsiveStyle
} from 'styled-system';


const wrap = responsiveStyle({
  prop: 'wrap',
  cssProperty: 'flexWrap'
})

export const Box = styled.div`
  overflow: hidden;
  ${space}
  ${width}
  ${fontSize}
  ${color}
  ${textAlign}
`;

export const Flex = styled.div`
  display: flex;
  ${justifyContent}
  ${wrap}
`;

export const IndexTitle = styled.h2`
  ${fontSize}
  color: inherit;
  margin: 1.25rem 0;
`;

export const IndexTitleBig = styled.h1`
  ${fontSize}
  color: inherit;
  margin: 1.05rem 0;
`;

export const ContentWrapper = styled.div`
  max-width: 40em;

  & h1, h2 {
    color: inherit;
    margin-top: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Layout/index.js